module.exports = __webpack_public_path__ + "static/media/maintenance-bg.d7676254.png";